import { render, staticRenderFns } from "./YouAndMeTextProduct.vue?vue&type=template&id=322d0810&scoped=true&"
import script from "./YouAndMeTextProduct.vue?vue&type=script&lang=js&"
export * from "./YouAndMeTextProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d0810",
  null
  
)

export default component.exports